var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5556_24215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.502C15.2479 19.502 19.502 15.2479 19.502 10C19.502 4.75224 15.2479 0.498047 10 0.498047C4.75224 0.498047 0.498047 4.75224 0.498047 10C0.498047 15.2479 4.75224 19.502 10 19.502Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99978 17.857C14.3392 17.857 17.857 14.3392 17.857 9.99978C17.857 5.66037 14.3392 2.14258 9.99978 2.14258C5.66037 2.14258 2.14258 5.66037 2.14258 9.99978C2.14258 14.3392 5.66037 17.857 9.99978 17.857Z",
    fill: "#FF8A14",
    stroke: "#EB6D00",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19.502C15.2479 19.502 19.502 15.2479 19.502 10C19.502 4.75224 15.2479 0.498047 10 0.498047C4.75224 0.498047 0.498047 4.75224 0.498047 10C0.498047 15.2479 4.75224 19.502 10 19.502Z",
    stroke: "#45413C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7919 6.77197H6.48352C5.45712 6.77197 4.83792 8.06437 5.39272 9.04637C6.45519 10.9393 7.76943 12.6794 9.29952 14.2192C9.51042 14.4441 9.80144 14.577 10.1096 14.589C10.4177 14.601 10.7182 14.4911 10.9459 14.2832C12.5724 12.7736 13.9145 10.9841 14.9083 8.99997C15.4215 8.01757 14.7963 6.77197 13.7919 6.77197Z",
    fill: "#FFF5EB",
    stroke: "#EB6D00",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5556_24215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdown-icon.f585e2bc90195d93696f5bfc4a7ac222.svg";
export { ForwardRef as ReactComponent };